
import React from 'react';
import { FaRegEnvelope } from 'react-icons/fa'; 
import './SopCtaSection.css'; 

const SopCtaSection = () => {
  return (
    <section className="_cTASectCont_x1A_">
      <div className="_sCCont_y2B_"> 
        <div className="_cIWrap_a2B_" style={{marginBottom:"0"}}>
          <FaRegEnvelope className="_cIcon_b3C_" /> 
        </div>
        <h2 className="_hTitle_s5E_ features-title _hTitle_z5E_"> 
          Questions or Feedback?
        </h2>
        <p className="_cDesc_d5C_"> 
          Our SOP evolves as Vanidya grows. If you have feedback or need clarification,
          <a href="mailto:support@vanidya.com" className="_cEmailLink_e6C_">
            email support@vanidya.com
          </a>
          .<br />
          Thank you for helping us set a higher standard in e-commerce and temple services.
        </p>
      </div>
    </section>
  );
};

export default SopCtaSection;
